export enum PODetailHeaders {
  PO_DETAILS = 'poDetails',
  TIMESHEET_RECORDS = 'timesheetRecords',
  INVOICE_RECORDS = 'invoiceRecords',
  RATES = 'rates',
  PENDING_RATES_REVIEW = 'pendingRatesReview',
  COMPLETION_FORM = 'completionForm',
}
